import React from "react";

const disclaimerLongFilePath =
process.env.REACT_APP_DISCLAIMER_LONG_FILE_PATH || "";

const Disclaimer = () => {
    return (
      <div style={styles.disclaimerbox}>
        <p>
        Disclaimer:The information on this website has been prepared by DV Securities, LLC (“DVS” or the “Firm”) and is intended solely for institutional investors, as defined in FINRA Rule 2210, and qualified DVS personnel. By accessing this site, you acknowledge and confirm that you meet these criteria.
All content is for informational purposes only and does not constitute an offer to sell or a solicitation to buy any security, derivative, or other financial instrument. Nothing herein should be construed as investment advice or a recommendation to engage in any transaction.
The information provided is confidential and intended solely for the designated recipient. Redistribution, retransmission, or disclosure, in whole or in part, without the Firm’s written consent is strictly prohibited. DVS makes no representations or warranties as to the accuracy, completeness, or timeliness of the information and disclaims any liability for reliance on it.
Access to certain materials may be restricted and require authentication. Unauthorized access, use, or distribution of site content is prohibited.
Each party should consult its own advisors regarding the financial, legal, tax, and regulatory implications of any potential transaction.
        </p>
      </div>
    );
  };
  
  const styles: { disclaimerbox: React.CSSProperties } = {
    disclaimerbox: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      zIndex: 5,
      bottom: 60,
      left: 0,
      width: '100%',
      color: 'gray',
      textAlign: 'left',
      justifyContent: 'center',
      fontSize: '10px',
      borderTop: '1px solid rgba(255, 255, 255, 0.37)',
      backgroundColor: '#0a1a2e',
      boxShadow: '0px -2px 5px rgba(0,0,0,0.1)',
    },
  };
  
  export default Disclaimer;
